
import pushMaps from './director/push-maps';
import personnelMaps from './director/personnel-maps';
import tableColumns from './director/table-columns';

export default {
    top_study_time: '学习时长',
    top_integral: '积分',
    top_course_hour: '课时',
    top_credit: '学分',
    top_how_to_get_integral: '如何获得积分？',
    top_identity: '身份',
    // -------hhy-----
    unit_day: '天',
    unit_hour: '小时',
    unit_minute: '分钟',
    no_data: '当前暂无符合条件的处理记录',
    no_member: '暂无团队成员!',
    search_placeholder: '请输入您要搜索的内容',
    load_more: '加载更多',
    no_more: '没有更多了',
    has_ended: '已结束',
    has_completed: '已结项',
    has_finished: '已完成',
    on_going: '进行中',
    wait_handle_record: '待处理记录',
    btn_train_manage: '班级管理',
    btn_train_detail: '班级详情',
    btn_detail: '查看详情',
    btn_go_lecturer: '去授课',
    btn_start_report: '开始提报',
    btn_continue_report: '继续提报',
    btn_start_markpaper: '开始评卷',
    btn_again_markpaper: '重新评卷',
    btn_go_invigilate: '进入监考',
    btn_go_approve: '去审批',
    btn_go_correct: '去批改',
    report_situation: ' 提报情况：',
    train_graduation_situation: '结业情况：',
    put_forward: '提报',
    exam_reference_person: '参考人：',
    exam_duration: '考试时长：',
    remain_exam_duration: '剩余时长：',
    invigilate: '监考',
    approve_originator: '送审人：',
    homework_submitter: '提交人：',
    team_members: 'Team members',
    all: 'All',
    team_contribution: 'Team contribution',
    my_team: 'My team',
    care_something: 'Everybody loves it',
    rank: 'Rankings',
    go_approve_before_tip: '审批状态已变更，请重新刷新页面',
    office_page: '办公主页',
    knowledge: 'knowledge',
    share: 'share',
    this_year: '(year)',
    yesterday: '(day)',
    activity: 'activity',
    bi_group: 'contrast group',
    avg_study_time: 'average time(h)',
    all_members: '全部成员',
    label_fullName: '姓名：',
    placeholder_fullName: '请输入姓名',
    label_name: '账号：',
    placeholder_name: '请输入账号',
    serial_number: '序号',
    fullName: '姓名',
    name: '账号',
    phone_number: '手机号',
    email: '邮箱',
    position: '岗位',
    attributive_department: '归属部门',
    job: '职务',
    join_time: '入职时间',
    close: '关闭',
    search: '搜索',
    export: '导出',
    view: '查看',
    operating: '操作',
    // -------qzm-----
    // -------xhf-----
    no_found: 'Sorry, the data was not found!',
    personnel_nodata: 'No related content at present!',
    personnel_loading: 'loading...',
    types_list: [
        { key: '', value: 'All' },
        { key: 1, value: 'Course' },
        { key: 2, value: 'Subject' },
        { key: 3, value: 'Exam' },
        { key: 4, value: 'Research' },
        { key: 5, value: 'Class' },
        { key: 6, value: 'Live' },
        { key: 7, value: 'Certification exam' }
    ],
    types_list_show: [
        '',
        'Co',
        'Su',
        'Ex',
        'Re',
        'Cl',
        'Li',
        'Ce'
    ],
    type_colors: {
        0: '52,157,31', // 直播
        1: '233,164,89', // 课程
        2: '231,132,132', // 专题
        3: '68,193,191', // 考试
        4: '52,157,31', // 调研
        5: '0,174,255', // 班级
        6: '89,145,233', // 直播
        7: '68,193,191' // 认证考试
    },
    status_colors: {
        1: '96,200,189', // 未开始
        2: '0,174,255', // 进行中
        3: '240,114,80', // 报名中
        4: '238,103,103', // 策划中
        5: '90,175,116', // 待实施
        6: '104,152,220', // 实施中
        7: '167,131,89', // 待结项
        8: '136,136,136' // 已结束
    },
    source_form: {
        1: '学习推送',
        2: '群主',
        3: '岗位',
        4: '职务',
        5: '主管'
    },
    'types-text': [
        'All',
        'Course',
        'Subject',
        'Exam',
        'Research',
        'Class',
        'Live',
        'Certification Exam'
    ],
    'exam-status': {
        1: 'Unreleased',
        2: 'In release',
        3: 'Upcoming ',
        4: 'Entering',
        5: 'In the exam',
        6: 'Over',
        7: 'Info updating',
    },
    'exam-detail-record-status': {
        0: 'Pass',
        1: 'Failed',
        3: 'Pending',
    },
    'exam-record-status': {
        0: 'All',
        1: 'Upcoming ',
        2: 'In progress',
        4: 'Unsubmitted',
        5: 'Pending',
        6: 'Pass',
        7: 'Fail',
        8: 'Completed',
        9: 'good',
        10: 'excellent'
    },
    'exam-type': {
        // 3、集团认证考试    4、省级认证考试
        0: 'All',
        1: 'Exam',
        2: 'Test',
        3: 'Certification exam',
        4: 'Certification exam',
    },
    'exam-person-center-status': {
        1: 'On Exam',
        2: 'Upcoming ',
        3: 'Approving',
        4: 'Pending',
        5: 'Completed',
    },
    'research-activity-status': {
        1: 'Unreleased',
        2: 'Upcoming ',
        3: 'In progress',
        4: 'Over',
        5: 'Revoked',
    },
    'research-record': {
        0: '未参与',
        1: '已完成'
    },
    'student-classinfo-status': {
        2: 'Planing',
        3: 'Entering',
        4: 'Pending',
        5: 'In progress',
        6: 'Incompleted',
        7: 'Completed',
        8: 'Revoked'
    },
    'course-info-study-status': {
        0: 'Upcoming ',
        1: 'Learning',
        2: 'Completed',
        3: 'quited',
        4: 'Completed',
        5: 'Pending',
        6: 'Rejected',
    },
    'subject-status': {
        0: 'Draft',
        1: 'Put on shelves',
        2: 'Pull off shelves',
        3: 'Approving',
        4: 'Rejected',
    },
    'live-status': {
        1: 'Upcoming',
        2: 'On live',
        3: 'Over',
        4: 'Revoked'
    },
    'gensee-status': {
        0: 'Unreleased',
        1: 'Upcoming ',
        2: 'In progress',
        3: 'Over',
        4: 'Revoked',
    },
    'course-task-view-detail-status': {
        0: 'not started',
        1: 'studying',
        2: 'finished',
        3: 'quited',
        4: 'finished'
    },
    'personnel-detail-activity-businessType': {
        0: '面授课程', 1: '考试', 2: '评估', 3: '调研', 4: '直播', 5: '作业', 6: '其他', 7: '考核考试', 8: '在线课程'
    },
    'personnel-detail-activity-status': {
        1: 'not started', 2: 'Incompleted', 3: 'finished'
    },
    'center-stage': [
        ['Upcoming', { 'not started': 1, Unreleased: 1, Pending: 5, Entering: 3 }],
        ['In progress', { 'In progress': 2, 'On live': 2, 'In the exam': 2, Planing: 4, Incompleted: 7 }],
        ['Over', { Over: 8, Completed: 8, Revoked: 8 }],
    ],
    'center-stage-status': {
        1: 'In progress',
        2: 'Revoked',
        3: 'Over',
    },
    'personnel-view': 'Personnel view',
    'task-view': 'Task view',
    minutes: ' minutes',
    nameNumber: 'Please enter your name or account number',
    graduation: 'graduation',
    score: 'score',
    result: 'Result',
    source: 'Source',
    'center.detail.all': 'All',
    'center.detail.completed': 'completed',
    'center.detail.notCompleted': 'not completed',
    'center.a.key.to.learn': ' learning',
    'center.archives.live.start-time': 'Starting time',
    'center.archives.live.end-time': 'Deadline',
    'center.archives.ask.push-time': 'Publish time',
    'center.class.class-period': 'Expire date',
    'center.create.live.estimate.time': 'Estimated time',
    'center.detail.implementationDepartment': 'Implementation department',
    'center.detail.publishDepartment': 'Publish department',
    'center.detail.teamMembers': 'Number of team members',
    'center.detail.search': 'Search',
    'center.detail.urge': 'Reminder',
    'center.record.index': 'S/N',
    'center.record.memberFullName': 'Name',
    'center.record.memberName': 'Account number',
    'center.record.organization': 'Organization',
    'center.record.completion': 'Completion',
    'center.record.totalTime': 'TotalTime',
    'center.record.graduation': 'Graduation',
    'center.record.operation': 'Operation',
    'center.record.businessName': 'Business name',
    'train.manage.study.isItCompulsory': 'Required',
    'train.manage.activityName': 'Title',
    'train.manage.activityType': 'Type of activity',
    'train.manage.teacher': 'Lecturer',
    'train.manage.completionRate': 'Rate of completion',
    'train.manage.activity.startTime': 'Starting time',
    'train.manage.activity.endTime': 'Deadline',
    'train.info.study-time': 'Class hours',
    'train.info.study-status': 'Status',
    'study.util.chnNumChar': ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'],
    'study.util.charset': ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'],
    'study.util.chnUnitChar': ['', '十', '百', '千'],
    'study.util.prefix': '第',
    'study.util.suffixChapter': '章',
    'study.util.suffixSection': '节',
    'exam.exam.bussiness.exam-time': 'Exam time span',
    'exam.exam.bussiness.exam-type': 'Type',
    'exam-subject.dialog.to-be-review': 'Pending',
    'exam.pass': 'Pass',
    'exam.flunk': 'Fail',
    rushLearnTips: {
        class: '请勾选至少一个未结业选项',
        course: '请勾选至少一个未开始选项',
        exam: '请勾选至少一个未开始选项',
        live: '请勾选至少一个未参与选项',
        research: '请勾选至少一个未参与选项',
        subject: '请勾选至少一个未开始选项',
        examInfo: '所选的考生记录中含有非未开始的数据，请重新选择',
        researchInfo: '所选的学员记录中含有已完成的数据，请重新选择'
    },
    examTips: '该资源已不存在',
    // -------wzq-----,
    warning_colors: {
        1: '#00AEFF', // 0%-50% 红色警告
        2: '#00AEFF', // 50%-75% 黄色显示
        3: '#00AEFF', // 50%-75% 蓝色显示

        // 1: '#F00', // 0%-50% 红色警告
        // 2: '#FF0', // 50%-75% 黄色显示
        // 3: '#00AEFF', // 50%-75% 蓝色显示
    },
    'push-sudy': {
        ...pushMaps
    },
    personnel: {
        ...personnelMaps
    },
    'table-columns': {
        ...tableColumns
    }
};
